module.exports = {
  siteTitle: 'Pranesh Portfolio',
  siteDescription:
    'Pranesh is an incoming AIML Developer, based in India, who loves learning new things and helping tech beginners and has built a number of projects using Python, and other technologies. He is good in ML, DL, GenAI, Agentic AI and a little web development.',
  siteKeywords:
    'Pranesh, pranesh, pranesh-2005, praneshs, AI engineer, web developer,  python, java, bit, erode, Pranesh BIT, Pranesh AIML, Pranesh Portfolio, Pranesh Punjai Puliampatti, Pranesh India, Pranesh GitHub, Pranesh LinkedIn, Pranesh Gudalur, Pranesh Resume',
  siteUrl: 'https://pranesh-2005.github.io',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-45666519-2',
  googleVerification: '8NlZmoYkELgzDBD3JUJhJttr5tMqIhDN_seWjyQXEk8',
  name: 'Pranesh',
  location: 'Punjai Puliampatti, India',
  email: 'praneshmadhan646@gmail.com',
  github: 'https://github.com/Pranesh-2005',
  twitterHandle: '@',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/Pranesh-2005',
    },
    {
      name: 'Hugging Face',
      url: 'https://huggingface.co/PraneshJs',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/pranesh5264/',
    },
    // {
    //   name: 'Codepen',
    //   url: 'https://codepen.io/yashitanamdeo',
    // },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/pranesh_____17',
    },
    // {
    //   name: 'Twitter',
    //   url: 'https://twitter.com/',
    // },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Skills',
      url: '/#skills',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
        {
      name: 'Certificates',
      url: '/#certificates',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
